import { LEVELS } from "../../data/content";
import { Reveal } from "./Reveal";

export const Levels = () => (
  <section id="levels" className="border-y border-line bg-sand/50 py-24 md:py-32">
    <div className="mx-auto max-w-7xl px-6">
      <Reveal>
        <p className="eyebrow">Your journey</p>
        <h2 className="mt-3 font-serif text-3xl tracking-tight text-ink sm:text-4xl md:text-5xl">
          Three levels, one goal
        </h2>
      </Reveal>

      <div className="mt-14 grid gap-10 md:grid-cols-3 md:gap-8">
        {LEVELS.map((level, i) => (
          <Reveal key={level.num} delay={i * 0.12}>
            <div className="border-t-2 border-pine/15 pt-6 transition-colors duration-300 hover:border-pine">
              <p className="font-mono text-sm text-gold">{level.num}</p>
              <h3 className="mt-4 font-serif text-2xl text-ink md:text-3xl">{level.name}</h3>
              <p className="mt-3 text-sm leading-relaxed text-ink-soft md:text-base">
                {level.description}
              </p>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);

export default Levels;
